export enum StorageType {
    UNKNOWN = 0,
    AZURE_BLOB_STORAGE = 1,
    AWS_BLOB_STORAGE = 2,
    GCP_BLOB_STORAGE = 3,
    DEFAULT_STORAGE = 4,
    REMOTE_STORAGE = 5,
}

export interface StorageSource {
    type: StorageType;
    name: string;
    origin: string;
    headers: {
        key: string;
        value: string;
    }[];
    seo_enabled: boolean;
}
